module.exports = __webpack_public_path__ + "media/centennial college - toolkit testimonials - video 1.ec16d061.mp4";